import { Route, Switch } from "react-router-dom";
import ExportacaoContabilListagemPage from "./Listagem/index";

function ExportacaoContabilPages() {
  return (
    <Switch>
      <Route
        exact
        path="/financeiro/exportacao-contabil"
        component={ExportacaoContabilListagemPage}
      />
    </Switch>
  );
}

export default ExportacaoContabilPages;
